import { useSelector } from 'react-redux';

export const useLoadingState = () => useSelector(state => state.app.loading);
export const useErrorState = () =>
  useSelector(state => state.app.errorOverlayState);
